import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material';
import Button from '@mui/material/Button';

const StyButton = styled(Button)(({ theme }) => ({
    borderRadius: theme.spacing(1),
    padding: `0 ${theme.spacing(1)}`,
    '&.MuiButtonBase-root': {
        minHeight: '2rem',
    },
}));

const SeeOriginalButton = ({ route }: { route: string }): JSX.Element => {
    const { t } = useTranslation();
    const title = t('indicators.seeOriginal');
    return (
        <Link to={route} target="_blank">
            <StyButton
                className="pendo-indicators-library-see-original"
                size="small"
                variant="outlined"
            >
                {title}
            </StyButton>
        </Link>
    );
};

export default SeeOriginalButton;
